import React from 'react';

import fetch from './../../fetch';

import utils from './../../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'orgName', label: '所属部门'},
    {key:'employeeCode', label: '职工代码'},
    {key:'realName', label: '姓名'},
    {key:'folderName', label: '授权文件夹名称'},
    {key:'authTypeDesc', label: '授权类型'},
    {key:'termName', label: '所属学期'},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('dossier/folder/auth/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('dossier/folder/auth/insert', data)
    .then(response => {
        Modal.success({
            title: '提示信息!',
            content: (
                <div>
                    <p>{response.message}</p>
                </div>
            ),
            onOk() {
                DataGrid.selections = [];
                //window.location.hash = 'classes/index';
            },
            okText:"确认",
        });

        
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            onOk() {},
            okText:"确认",
        })
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('dossier/folder/auth/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    Modal.success({
                        title: '提示信息',
                        content: (
                            <div>
                            <p>{response.message}</p>
                            </div>
                        ),
                        okText:"确认",
                        onOk() {
                            DataGrid.selections = [];
                            DataGrid.refresh();
                        },
                    });
                }).catch(error => {
                    Modal.error({
                        title: '错误提示',
                        content: (
                            <div>
                            <p>{error.message}</p>
                            </div>
                        ),
                        okText:"确认",
                        onOk() {
                        },
                    })
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'dossier/folder/auth/'+ url;
};

/**
 * @method copy
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
 const copy = (params) => {
    return fetch.post('dossier/folder/auth/save/copy', params)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
            DataGrid.refresh();
        }
    }).catch(error => {
        return error;
    });
}

export default {
    insert,
    querySearch,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    copy
}